import { render } from "./DeactivateVerifyView.vue?vue&type=template&id=8989a2fa"
import script from "./DeactivateVerifyView.vue?vue&type=script&lang=js"
export * from "./DeactivateVerifyView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__